import {
    OPEN_EULA_PROMPT,
    OPEN_ON_FETCH,
    ACCEPT_EULA,
    DECLINE_EULA,
    SET_BUTTON_TEXTS,
} from './constants'

export function openEulaPrompt(userId, newEula) {
    return { type: OPEN_EULA_PROMPT, payload: { userId, newEula } }
}

export function openOnFetch() {
    return { type: OPEN_ON_FETCH }
}

export function acceptEula() {
    return { type: ACCEPT_EULA }
}

export function declineEula() {
    return { type: DECLINE_EULA }
}

export function setButtonTexts(acceptText, declineText) {
    return {
        type: SET_BUTTON_TEXTS,
        payload: { acceptText, declineText },
    }
}



// WEBPACK FOOTER //
// ./src/features/Eula/data/prompt/actions.js